import { Card } from '../../components/card';
import { CheckedIcon } from '../../assets/custom-icons';
import { SITELINK } from '../../app-routes/Links';
import { useState } from 'react';
import { FreeBigGift, FreeSmallGift, PremiumBigGift, PremiumSmallGift, UltimateBigGift, UltimateSmallGift } from '../../assets/images';
import TopBar from '../../layouts/~includes/TopBar';
import { useTheme } from '../../context/theme-context';

const Subscription = () => {
  document.body.classList.remove('overflow-hidden');
  const [activeTab, setActiveTab] = useState<'free' | 'premium' | 'ultimate'>('free');

  const { isDarkMode } = useTheme();

  // Define color constants
  const colors = {
    free: '#1976d2',
    premium: '#faa700',
    ultimate: '#4caf50'
  };

  const getTabConfig = () => {
    switch (activeTab) {
      case 'free':
        return {
          color: colors.free,
          price: 0,
          content: ['5 Sponsored Posts', '2 Boost Per Month', '1 Premium Post'],
          icon: FreeSmallGift,
          mainImage: FreeBigGift,
        };
      case 'premium':
        return {
          color: colors.premium,
          price: 9,
          content: ['5 Sponsored Posts', '8 Boost Per Month', '15 Premium Post'],
          icon: PremiumSmallGift,
          mainImage: PremiumBigGift,
        };
      case 'ultimate':
        return {
          color: colors.ultimate,
          price: 15,
          content: ['10 Sponsored Posts', '25 Boost Per Month', 'Unlimited Premium Post'],
          icon: UltimateSmallGift,
          mainImage: UltimateBigGift,
        };
      default:
        return {
          color: '#ffffff',
          price: 0,
          content: ['Default content'],
          icon: 'default-icon',
        };
    }
  };

  const tabConfig = getTabConfig();

  // Get tab button styles based on active state
  const getTabButtonStyle = (tab: string) => {
    const baseStyle = "px-6 py-2.5 rounded-lg flex items-center justify-center transition-all";
    if (activeTab === tab) {
      switch(tab) {
        case 'free':
          return `${baseStyle} text-white bg-[#1976d2]`;
        case 'premium':
          return `${baseStyle} text-white bg-[#faa700]`;
        case 'ultimate':
          return `${baseStyle} text-white bg-[#4caf50]`;
        default:
          return baseStyle;
      }
    }
    return `${baseStyle}`;
  };

  return (
    <section className="bg-[#E1F0F8F7] dark:bg-neutral-800 min-h-screen">
      {/* top lead area and post btn */}
      <div className="fixed top-0 w-full z-50">
        <TopBar title="Premium Service" link={SITELINK.HOME} />
      </div>

      <section className="bg-white dark:bg-neutral-800 mt-[60px] md:mt-0 min-h-screen">
        <div className="py-6 px-3 rounded-md bg-white dark:bg-neutral-800 mx-auto box-border max-w-7xl">
          <div className="flex flex-col">
            <h1 className="font-medium mb-0">Select Plan</h1>

            <div className='flex items-center mt-4 gap-2 flex-wrap'>
              {['free', 'premium', 'ultimate'].map((item) => (
                <button
                  key={item}
                  className={getTabButtonStyle(item)}
                  onClick={() => setActiveTab(item as 'free' | 'premium' | 'ultimate')}
                >
                  <div className="text-sm font-medium capitalize">{item}</div>
                </button>
              ))}
            </div>

            <div 
              className="mt-6 w-full shadow-sm border dark:border-neutral-800 h-40 rounded-xl p-3 flex flex-col justify-between"
              style={{
                background: `linear-gradient(to right, ${isDarkMode ? '#ccc' : '#FFFFFF'} 0%, ${tabConfig.color} 100%)`
              }}
            >
              <span className='font-bold capitalize'>{activeTab}</span>
              <div className='text-xs font-medium'>
                You are currently on the <span className='capitalize'>{activeTab}</span> Version. 
                You can Upgrade to the other Versions.
              </div>
              <div className='flex justify-between items-end'>
                <button 
                  className="text-white text-sm py-2 px-4 rounded-lg"
                  style={{ backgroundColor: tabConfig.color }}
                >
                  Select Plan
                </button>
                <div className='size-[48px]'>
                  <img src={tabConfig.icon} className='w-full h-full object-contain' alt='icon_image'/>
                </div>
              </div>
            </div>

            <div className="grid w-full grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 dark:bg-[#ccc] rounded-lg">
              <Card className="rounded-lg h-[434px] flex flex-col justify-between overflow-hidden dark:border-neutral-800">
                <div 
                  className="rounded-lg flex h-[110px] flex-col items-center text-white justify-center mb-4"
                  style={{ backgroundColor: tabConfig.color }}
                >
                  <p className="text-sm capitalize mb-3">{activeTab}</p>
                  <h1 className="text-2xl font-bold">${tabConfig.price} / Month</h1>
                </div>
                <div className="flex flex-col gap-8 ml-10 flex-1 relative">
                  {tabConfig.content.map((item, index:number) => (
                    <div className="flex gap-2" key={index}>
                      <img src={CheckedIcon} alt="check_icon" />
                      <p className="text-[#003049]">{item}</p>
                    </div>
                  ))}

                  <div className="absolute -right-2 -bottom-2 size-[140px]">
                    <img src={tabConfig.mainImage} alt='main_image' className='object-contain'/>
                  </div>
                </div>
                <button
                  className="w-full mt-2 text-sm py-3.5 rounded-lg text-white mx-auto"
                  style={{ backgroundColor: tabConfig.color }}
                  type="submit"
                >
                  Current Plan
                </button>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Subscription;